import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import { fmtARS } from '../lib/money';
import '../styles/Regalos.css';

const CATEGORIAS = ['flores', 'bombones', 'desayunos', 'bebidas', 'artesanales', 'otros'];
const EMPTY = { nombre: '', categoria: 'flores', descripcion: '', email: '', telefono: '' };
const STATUS_LABELS = {
  pending_payment: 'Pago pendiente', paid: 'Esperando respuesta', accepted: 'Aceptado',
  delivered: 'Entregado', rejected: 'Rechazado', refunded: 'Reembolsado', expired: 'Vencido',
};

function NuevoProducto({ comercioId, onDone, success, error }) {
  const [f, setF] = useState({ nombre: '', descripcion: '', precio: '', costo_envio: '' });
  const submit = async (e) => {
    e.preventDefault();
    const precio = parseInt(f.precio, 10);
    if (!f.nombre.trim() || !precio || precio < 1) { error('Completá nombre y un precio válido.'); return; }
    try {
      await api.adminCrearProducto(comercioId, { nombre: f.nombre.trim(), descripcion: f.descripcion.trim(), precio, costo_envio: parseInt(f.costo_envio, 10) || 0 });
      success('Producto agregado.');
      setF({ nombre: '', descripcion: '', precio: '', costo_envio: '' });
      onDone();
    } catch (err) { error(err.message); }
  };
  return (
    <form onSubmit={submit} style={{ marginTop: 12 }}>
      <div className="comercio-form-grid">
        <input className="form-input" placeholder="Nombre del producto" value={f.nombre} onChange={e => setF({ ...f, nombre: e.target.value })} />
        <input className="form-input" placeholder="Descripción" value={f.descripcion} onChange={e => setF({ ...f, descripcion: e.target.value })} />
        <input className="form-input" type="number" min="1" step="1" placeholder="Precio del comercio ARS" value={f.precio} onChange={e => setF({ ...f, precio: e.target.value })} />
        <input className="form-input" type="number" min="0" step="1" placeholder="Envío ARS" value={f.costo_envio} onChange={e => setF({ ...f, costo_envio: e.target.value })} />
      </div>
      <button type="submit" className="btn btn-outline btn-sm">+ Agregar producto</button>
    </form>
  );
}

export default function ComerciosAdmin({ success, error }) {
  const [comercios, setComercios] = useState([]);
  const [regalos, setRegalos] = useState([]);
  const [totales, setTotales] = useState({ ventas: 0, comision: 0 });
  const [form, setForm] = useState(EMPTY);

  const load = useCallback(async () => {
    try { const d = await api.adminComercios(); setComercios(d.comercios || []); }
    catch (e) { error(e.message || 'Error cargando comercios.'); }
    try {
      const d = await api.adminRegalos();
      setRegalos(d.regalos || []);
      setTotales(d.totales || { ventas: 0, comision: 0 });
    } catch { /* sin ventas todavía */ }
  }, [error]);

  useEffect(() => { load(); }, [load]);

  const crear = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim() || !form.email.trim()) { error('Nombre y correo son obligatorios.'); return; }
    try {
      await api.adminCrearComercio(form);
      success('Comercio creado.');
      setForm(EMPTY);
      load();
    } catch (err) { error(err.message); }
  };

  const copiarTexto = async (texto, okMsg) => {
    try { await navigator.clipboard.writeText(texto); success(okMsg); }
    catch { window.prompt('Copiá el enlace:', texto); }
  };
  const copiar = (c) => copiarTexto(c.connect_url, 'Enlace copiado.');

  // Le manda por mail el enlace para elegir contraseña y lo copia por si hay que pasarlo por WhatsApp
  const enviarAcceso = async (c) => {
    try {
      const { url } = await api.adminAccesoComercio(c.id);
      await copiarTexto(url, `Le mandamos el acceso al panel a ${c.email}. El enlace también quedó copiado.`);
      load();
    } catch (err) { error(err.message); }
  };

  const run = async (fn, okMsg) => {
    try { await fn(); if (okMsg) success(okMsg); load(); }
    catch (err) { error(err.message); }
  };

  const subirFoto = (p, file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append('photo', file);
    run(() => api.adminFotoProducto(p.id, fd), 'Foto actualizada.');
  };

  const subirLogo = (c, file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append('photo', file);
    run(() => api.adminLogoComercio(c.id, fd), 'Logo actualizado.');
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div>
      <form className="comercio-card" onSubmit={crear}>
        <h3 style={{ fontFamily: 'var(--font-display)', color: 'white', marginBottom: 14 }}>Nuevo comercio</h3>
        <div className="comercio-form-grid">
          <div className="form-group"><label className="form-label">Nombre</label>
            <input className="form-input" value={form.nombre} onChange={set('nombre')} /></div>
          <div className="form-group"><label className="form-label">Categoría</label>
            <select className="form-input" value={form.categoria} onChange={set('categoria')}>
              {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
            </select></div>
          <div className="form-group"><label className="form-label">Descripción</label>
            <input className="form-input" value={form.descripcion} onChange={set('descripcion')} /></div>
          <div className="form-group"><label className="form-label">Correo (donde llegan los pedidos)</label>
            <input className="form-input" type="email" value={form.email} onChange={set('email')} /></div>
          <div className="form-group"><label className="form-label">Teléfono</label>
            <input className="form-input" value={form.telefono} onChange={set('telefono')} /></div>
        </div>
        <button type="submit" className="btn btn-primary btn-sm">Crear comercio</button>
      </form>

      {/* Acá solo Cupido Delivery; los locales de Cupido Descuentos se aprueban en su pestaña */}
      {comercios.filter(c => c.en_delivery).map(c => (
        <div key={c.id} className="comercio-card" style={c.activo ? {} : { opacity: 0.6 }}>
          <div className="regalo-head">
            <div>
              {c.logo_path && <img src={c.logo_path} alt="" className="comercio-logo" style={{ verticalAlign: 'middle', marginRight: 8 }} />}
              <span className="regalo-name">{c.nombre}</span>{' '}
              <span className="badge badge-gris">{c.categoria}</span>{' '}
              {c.en_descuentos ? <span className="badge badge-gris">🏷️ También en Cupido Descuentos</span> : null}{' '}
              {c.estado === 'pendiente' && <span className="badge badge-dorado">⏳ Pendiente de aprobación</span>}
              {c.estado === 'rechazado' && <span className="badge badge-rojo">Rechazado</span>}
              <div className="regalo-detail">{c.email}{c.telefono ? ` · ${c.telefono}` : ''}</div>
            </div>
            <div className="admin-actions">
              {c.estado !== 'aprobado' && (
                <button className="btn btn-primary btn-sm" onClick={() => run(() => api.adminEstadoComercio(c.id, 'aprobado'), 'Comercio aprobado. Le avisamos por correo.')}>✅ Aprobar</button>
              )}
              {c.estado === 'pendiente' && (
                <button className="btn btn-outline btn-sm" onClick={() => window.confirm(`¿Rechazar a ${c.nombre}?`) && run(() => api.adminEstadoComercio(c.id, 'rechazado'), 'Solicitud rechazada.')}>Rechazar</button>
              )}
              <span className={`badge ${c.conectado ? 'badge-verde' : 'badge-dorado'}`}>
                {c.conectado ? '✅ MercadoPago conectado' : '⚠️ Sin conectar'}
              </span>
              {c.estado === 'aprobado' && <button className="btn btn-outline btn-sm" onClick={() => copiar(c)}>Copiar enlace de conexión</button>}
              <label className="btn btn-outline btn-sm" style={{ cursor: 'pointer' }}>
                🖼️ Logo
                <input type="file" accept="image/*" style={{ display: 'none' }}
                  onChange={e => { subirLogo(c, e.target.files[0]); e.target.value = ''; }} />
              </label>
              <button className="btn btn-outline btn-sm" onClick={() => enviarAcceso(c)}>
                {c.panel_activo ? '🔑 Reenviar acceso al panel' : '🔑 Enviar acceso al panel'}
              </button>
              <button className="btn btn-outline btn-sm"
                onClick={() => run(() => api.adminEditarComercio(c.id, { activo: !c.activo }))}>
                {c.activo ? 'Desactivar' : 'Activar'}
              </button>
            </div>
          </div>
          <p className="regalo-note" style={{ marginTop: 8 }}>
            {c.estado === 'pendiente'
              ? 'Se registró solo desde /comercio. Aprobalo para que aparezca en Cupido Delivery (Regalos y +) y pueda conectar su Mercado Pago.'
              : `Mandale el enlace de conexión para que conecte su Mercado Pago (o que lo haga desde su panel). Recién ahí puede vender.${c.panel_activo ? '' : ' Todavía no entró a su panel.'}`}
          </p>

          <div className="comercio-productos">
            {(c.productos || []).map(p => (
              <div key={p.id} className="comercio-producto" style={p.activo ? {} : { opacity: 0.6 }}>
                {p.foto_path && <img src={p.foto_path} alt={p.nombre} />}
                <div style={{ flex: 1, minWidth: 120 }}>
                  <div className="regalo-name" style={{ fontSize: 14 }}>{p.nombre}</div>
                  <div className="regalo-detail" style={{ marginTop: 0 }}>
                    {fmtARS(p.precio)} + envío {fmtARS(p.costo_envio)} · cliente paga {fmtARS(p.precio_final)}
                  </div>
                </div>
                <label className="btn btn-outline btn-sm" style={{ cursor: 'pointer' }}>
                  📷 Foto
                  <input type="file" accept="image/*" style={{ display: 'none' }}
                    onChange={e => { subirFoto(p, e.target.files[0]); e.target.value = ''; }} />
                </label>
                <button className="btn btn-outline btn-sm"
                  onClick={() => run(() => api.adminEditarProducto(p.id, { activo: !p.activo }))}>
                  {p.activo ? 'Desactivar' : 'Activar'}
                </button>
              </div>
            ))}
          </div>
          <NuevoProducto comercioId={c.id} onDone={load} success={success} error={error} />
        </div>
      ))}

      <h3 style={{ fontFamily: 'var(--font-display)', color: 'white', margin: '24px 0 12px' }}>Regalos vendidos</h3>
      <div className="users-table-wrap">
        <table className="users-table">
          <thead>
            <tr><th>Fecha</th><th>De → Para</th><th>Comercio</th><th>Producto</th><th>Precio</th><th>Comisión (10%)</th><th>Estado</th></tr>
          </thead>
          <tbody>
            {regalos.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', color: 'var(--texto-muted)' }}>Todavía no hay ventas.</td></tr>
            ) : regalos.map(r => (
              <tr key={r.id}>
                <td>{r.created_at ? new Date(r.created_at).toLocaleDateString('es-AR') : '—'}</td>
                <td>{r.from_name} → {r.to_name}</td>
                <td>{r.comercio_nombre}</td>
                <td>{r.producto_nombre}</td>
                <td>{fmtARS(r.precio)}</td>
                <td>{fmtARS(r.comision)}</td>
                <td><span className="badge badge-gris">{STATUS_LABELS[r.status] || r.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p style={{ marginTop: 12, fontWeight: 700, color: 'white' }}>
        Ventas: {fmtARS(totales.ventas)} · Tu comisión: {fmtARS(totales.comision)}
      </p>
    </div>
  );
}
